/** Enum bersama antara API, web, dan (nanti) klien mobile. */
export const ROLES = [
    "INSTITUT_ADMIN",
    "FAKULTAS_ADMIN",
    "PRODI_ADMIN",
    "DOSEN",
    "MAHASISWA",
    "UNIT_OPERATOR",
];
export const ACTIVITY_STATUSES = [
    "DRAFT",
    "SUBMITTED",
    "UNDER_REVIEW",
    "APPROVED",
    "REJECTED",
    "ARCHIVED",
];
export const VALIDATION_STATUSES = ["PENDING", "APPROVED", "REJECTED"];
/** Status persetujuan akun (pendaftaran mandiri berstatus PENDING). */
export const APPROVAL_STATUSES = ["PENDING", "APPROVED", "REJECTED"];
export const SEMESTER_TYPES = ["GANJIL", "GENAP"];
export const PARTICIPANT_TYPES = ["DOSEN", "MAHASISWA", "EKSTERNAL"];
export const ROLE_LABELS = {
    INSTITUT_ADMIN: "Admin Institut",
    FAKULTAS_ADMIN: "Admin Fakultas",
    PRODI_ADMIN: "Admin Program Studi",
    DOSEN: "Dosen",
    MAHASISWA: "Mahasiswa",
    UNIT_OPERATOR: "Operator Unit",
};
export const ACTIVITY_STATUS_LABELS = {
    DRAFT: "Draf",
    SUBMITTED: "Diajukan",
    UNDER_REVIEW: "Sedang Ditelaah",
    APPROVED: "Disetujui",
    REJECTED: "Ditolak",
    ARCHIVED: "Diarsipkan",
};
export const VALIDATION_STATUS_LABELS = {
    PENDING: "Menunggu Validasi",
    APPROVED: "Tervalidasi",
    REJECTED: "Ditolak",
};
export const APPROVAL_STATUS_LABELS = {
    PENDING: "Menunggu Persetujuan",
    APPROVED: "Aktif",
    REJECTED: "Pendaftaran Ditolak",
};
export const PARTICIPANT_TYPE_LABELS = {
    DOSEN: "Dosen",
    MAHASISWA: "Mahasiswa",
    EKSTERNAL: "Eksternal",
};
export const SEMESTER_TYPE_LABELS = {
    GANJIL: "Ganjil",
    GENAP: "Genap",
};
/** Role yang berwenang memvalidasi kegiatan. */
export const VALIDATOR_ROLES = ["PRODI_ADMIN", "FAKULTAS_ADMIN", "INSTITUT_ADMIN"];
/** Role yang boleh melihat antrean validasi di UI. */
export const ADMIN_ROLES = ["PRODI_ADMIN", "FAKULTAS_ADMIN", "INSTITUT_ADMIN"];
//# sourceMappingURL=enums.js.map